<template>
  <div class="triplea-search-component">
    <div class="container">
      <div class="row">
        <div class="search-component-text-bloc">
          <h1>Imóveis alto padrão Triple A</h1>
          <h2>Imóveis alto padrão exclusivos e personalizados para você</h2>
        </div>
      </div>
      <div class="search-component-tab-row">
        <div class="search-component-tab-bloc">
          <div class="search-component-tab-card">
            <ul>
              <li>
                <button
                  class="search-component-tab-button"
                  :class="{ active: activeTab === 'comprar' }"
                  @click="selectTab('comprar')"
                >
                  Comprar
                </button>
              </li>
              <!-- <li>
                <button
                  class="search-component-tab-button"
                  :class="{ active: activeTab === 'alugar' }"
                  @click="selectTab('alugar')"
                >
                  Alugar
                </button>
              </li> -->
              <li>
                <button
                  @click="$bvModal.show('AdvertiseModal')"
                  class="search-component-tab-button"
                >
                  Anunciar
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div class="search-component-content-bloc">
          <div class="search-component-content-card">
            <div class="tab-content">
              <div
                v-show="activeTab === 'comprar'"
                class="tab-pane fade"
                :class="{ show: activeTab === 'comprar', active: activeTab === 'comprar' }"
              >
                <div class="search-component-content-tabitem">
                  <div class="property-type-filter-bloc has-right-border as-button"
                      @click="toggleDropdown"
                      v-click-outside="closeDropdown"
                      ref="filterBloc"
                    >
                    <div class="property-type-filter-icon-box">
                      <span>
                        <img src="@/assets/img/triplea/home/filter-icons/home.svg" />
                      </span>
                    </div>
                    <div class="property-type-filter-text-box">
                      <h5>Tipo de imóveis:</h5>
                      <h6>Selecione tipo de imóvel</h6>
                    </div>
                    <div class="property-type-filter-arrow-box" :class="isDropdownOpen">
                      <DropdownArrowIcon v-if="!isDropdownOpen"/>
                      <CloseXIcon v-if="isDropdownOpen"/>
                    </div>
                    <div
                      v-show="isDropdownOpen"
                      class="property-type-dropdown"
                      ref="dropdown"
                      @click.stop
                    >
                    <div class="property-type-buttons-wrapper">
                      <div
                        v-for="type in propertyTypes"
                        :key="type.value"
                        class="property-type-button"
                        :class="{ active: search_params.propertieType.includes(type.value) }"
                        @click="togglePropertyType(type.value)"
                      >
                        <component :is="type.icon" />
                        <p>{{ type.label }}</p>
                      </div>
                    </div>

                    <div v-show="!show_other_types" class="property-othertype-wrapper input-filters">
                        <div class="property-othertype-button-wrapper">
                          <button class="property-othertype-button" @click="() => { show_other_types = !show_other_types; } ">Outros tipos de imóvel</button>
                        </div>
                      </div>
                      <div v-show="show_other_types" class="property-types-wrapper mt-3">
                        <div class="TripleaVSelectMultiple-wrapper">
                            <label class="use_icon house" for="">
                                <span class="text">{{ __("Tipos de imóveis") }}:</span>
                            </label>
                            <TripleaVSelectMultiple placeholder="Selecione o tipo de imóvel"
                                v-model="search_params.propertieType" :options="allPropertyTypes"/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="property-type-filter-bloc has-right-border">
                    <div class="property-type-filter-icon-box">
                      <span>
                        <img src="@/assets/img/triplea/home/filter-icons/pin.svg" />
                      </span>
                    </div>
                    <div class="property-type-filter-input-box">
                      <h5>Cidade</h5>
                      <input
                        class=""
                        placeholder="Selecione a cidade"
                        v-model="filters_queries.city"
                        @input="handleOpenSearch('city')"
                        @keydown="handleKeydown($event, 'city')"
                      />
                    </div>
                    <div
                    v-show="filters_results.cities.length > 0"
                    class="property-type-search-results"
                    ref="cityResults">
                      <ul>
                        <li
                        v-for="(result, index) in filters_results.cities"
                        :key="result.id"
                        :class="{ 'focused': index === focusedIndex }"
                        @click="selectResultCity(result)"
                        >
                          {{ result.city }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="property-type-filter-bloc has-right-border">
                    <div class="property-type-filter-icon-box">
                      <span>
                        <img src="@/assets/img/triplea/home/filter-icons/map-pin.svg" />
                      </span>
                    </div>
                    <div class="property-type-filter-input-box">
                      <h5>Bairro</h5>
                      <input
                        class=""
                        placeholder="Selecione o bairro"
                        v-model="filters_queries.neighborhood"
                        @input="handleOpenSearch('neighborhood')"
                        @keydown="handleKeydown($event, 'neighborhood')"
                      />
                    </div>
                    <div
                      v-if="filters_results.neighborhoods.length > 0"
                      class="property-type-search-results"
                      ref="neighborhoodResults"
                    >
                      <ul>
                        <li
                          v-for="(result, index) in filters_results.neighborhoods"
                          :key="index"
                          :class="{ 'focused': index === focusedIndex }"
                          @click="selectResultNeighborhood(result)"
                        >
                          {{ result }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="property-type-filter-bloc has-right-border">
                    <button @click="handleSearch" class="property-type-filter-search-button">
                      <SearchIcon />
                      Encontrar imóveis
                    </button>
                  </div>
                </div>
              </div>
              <div
                v-show="activeTab === 'alugar'"
                class="tab-pane fade"
                :class="{ show: activeTab === 'alugar', active: activeTab === 'alugar' }"
              >
              <div class="search-component-content-tabitem">
                  <div class="property-type-filter-bloc has-right-border as-button" @click="toggleDropdown">
                    <div class="property-type-filter-icon-box">
                      <span>
                        <img src="@/assets/img/triplea/home/filter-icons/home.svg" />
                      </span>
                    </div>
                    <div class="property-type-filter-text-box">
                      <h5>Tipo de imóveis:</h5>
                      <h6>Selecione tipo de imóvel</h6>
                    </div>
                    <div class="property-type-filter-arrow-box">
                      <DropdownArrowIcon v-if="!isDropdownOpen"/>
                      <CloseXIcon v-if="isDropdownOpen"/>
                    </div>
                    <div
                      v-if="isDropdownOpen"
                      class="property-type-dropdown"
                      ref="dropdown"
                      @click.stop
                    >
                      <div class="property-type-buttons-wrapper">
                        <div
                          v-for="type in propertyTypes"
                          :key="type.value"
                          class="property-type-button"
                          :class="{ active: search_params.propertieType.includes(type.value) }"
                          @click="togglePropertyType(type.value)"
                        >
                          <component :is="type.icon" />
                          <p>{{ type.label }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="property-type-filter-bloc has-right-border">
                    <div class="property-type-filter-icon-box">
                      <span>
                        <img src="@/assets/img/triplea/home/filter-icons/pin.svg" />
                      </span>
                    </div>
                    <div class="property-type-filter-input-box">
                      <h5>Cidade</h5>
                      <input
                        class=""
                        placeholder="ex. Curitiba"
                        v-model="filters_queries.city"
                        @input="handleOpenSearch('city')"
                        @keydown="handleKeydown($event, 'city')"
                      />
                    </div>
                    <div
                    v-show="filters_results.cities.length > 0"
                    class="property-type-search-results"
                    ref="cityResults">
                      <ul>
                        <li
                        v-for="(result, index) in filters_results.cities"
                        :key="result.id"
                        :class="{ 'focused': index === focusedIndex }"
                        @click="selectResultCity(result)"
                        >
                          {{ result.city }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="property-type-filter-bloc has-right-border">
                    <div class="property-type-filter-icon-box">
                      <span>
                        <img src="@/assets/img/triplea/home/filter-icons/map-pin.svg" />
                      </span>
                    </div>
                    <div class="property-type-filter-input-box">
                      <h5>Bairro</h5>
                      <input
                        class=""
                        placeholder="ex. Batel"
                        v-model="filters_queries.neighborhood"
                        @input="handleOpenSearch('neighborhood')"
                        @keydown="handleKeydown($event, 'neighborhood')"
                      />
                    </div>
                    <div
                      v-if="filters_results.neighborhoods.length > 0"
                      class="property-type-search-results"
                      ref="neighborhoodResults"
                    >
                      <ul>
                        <li
                          v-for="(result, index) in filters_results.neighborhoods"
                          :key="index"
                          :class="{ 'focused': index === focusedIndex }"
                          @click="selectResultNeighborhood(result)"
                        >
                          {{ result }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="property-type-filter-bloc has-right-border">
                    <button @click="handleSearch" class="property-type-filter-search-button">
                      <SearchIcon />
                      Encontrar imóveis
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import "@/assets/scss/custom/triplea/components/_home_search_component.scss"
  import DropdownArrowIcon from '@/components/icons/DropdownArrowIcon.vue'
  import CloseXIcon from '@/components/icons/CloseXIcon.vue'
  import ApartamentoIcon from '@/components/icons/FilterIcons/ApartamentoIcon.vue'
  import CasaESobradoIcon from '@/components/icons/FilterIcons/CasaESobradoIcon.vue'
  import ComercialIcon from '@/components/icons/FilterIcons/ComercialIcon.vue'
  import GardenIcon from '@/components/icons/FilterIcons/GardenIcon.vue'
  import CoberturaIcon from '@/components/icons/FilterIcons/CoberturaIcon.vue'
  import TerrenoIcon from '@/components/icons/FilterIcons/TerrenoIcon.vue'
  import SearchIcon from '@/components/icons/FilterIcons/SearchIcon.vue'
  import PropertiesService from "../../../../../services/PropertiesService";
  import TripleaVSelectMultiple from "./TripleaVSelectMultiple.vue";


  export default {
    components: {
      DropdownArrowIcon,
      ApartamentoIcon,
      CasaESobradoIcon,
      ComercialIcon,
      GardenIcon,
      CoberturaIcon,
      TerrenoIcon,
      SearchIcon,
      CloseXIcon,
      TripleaVSelectMultiple,
    },
    data() {
      return {
        activeTab: "comprar",
        isDropdownOpen: false,
        filters_options: {
          cities: [],
          neighborhoods: [],
        },
        filters_queries: {
          city: "",
          neighborhood: "",
        },
        filters_results: {
          cities: [],
          neighborhoods: [],
        },
        search_params: {
          city: "",
          neighborhood: "",
          propertieType: []
        },
        propertyTypes: [
          { value: "Apartamento", label: "Apartamento", icon: "ApartamentoIcon" },
          { value: "Sobrado", label: "Casa e Sobrado", icon: "CasaESobradoIcon" },
          { value: "comercial", label: "Comercial", icon: "ComercialIcon" },
          { value: "Terreno", label: "Terreno", icon: "TerrenoIcon" },
          { value: "Garden", label: "Garden", icon: "GardenIcon" },
          { value: "Cobertura", label: "Cobertura", icon: "CoberturaIcon" },
        ],
        allPropertyTypes: [],
        focusedIndex: -1,
        show_other_types: false,
      };
    },
    methods: {
      // control active tab
      selectTab(tab) {
        this.activeTab = tab;
      },

      // control property type dropdown
      toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
        if (!this.isDropdownOpen) {
          this.show_other_types = false;
        }
      },
      closeDropdown() {
        // chamado pela diretiva quando clica fora de `filterBloc`
        this.isDropdownOpen = false;
        this.show_other_types = false;
      },
      handleClickOutside(event) {
        const clickedOutsideCity = this.$refs.cityResults && !this.$refs.cityResults.contains(event.target);
        const clickedOutsideNeighborhood = this.$refs.neighborhoodResults && !this.$refs.neighborhoodResults.contains(event.target);
        const clickedOutsideDropdownFilter = this.$refs.dropdownFilter && !this.$refs.dropdownFilter.contains(event.target);

        if (clickedOutsideCity) {
          this.filters_results.cities = [];
          this.focusedIndex = -1;
        }
        if (clickedOutsideNeighborhood) {
          this.filters_results.neighborhoods = [];
          this.focusedIndex = -1;
        }

        if (clickedOutsideDropdownFilter) {
          this.isDropdownOpen = false;
          this.show_other_types = false;
        }
      },
      
      // to maintain selected property type
      togglePropertyType(type) {
        const idx = this.search_params.propertieType.indexOf(type);
        if (idx === -1) {
          this.search_params.propertieType.push(type);
        } else {
          this.search_params.propertieType.splice(idx, 1);
        }
      },
      
      // control selected city
      handleKeydown(event, type) {
        const results = type === "city" ? this.filters_results.cities : this.filters_results.neighborhoods;
        const resultsLength = results.length;
        if (event.key === "ArrowDown") {
          this.focusedIndex = (this.focusedIndex + 1) % resultsLength;
        } else if (event.key === "ArrowUp") {
          this.focusedIndex = (this.focusedIndex - 1 + resultsLength) % resultsLength;
        } else if (event.key === "Enter") {
          if (this.focusedIndex >= 0) {
            if (type === "city") {
              this.selectResultCity(results[this.focusedIndex]);
            } else if (type === "neighborhood") {
              this.selectResultNeighborhood(results[this.focusedIndex]);
            }
          }
        }
      },


      // to maintain city search
      filterCityResults() {
        const query = this.filters_queries.city.toLowerCase();
        this.filters_results.cities = this.filters_options.cities.filter(city =>
          city.city.toLowerCase().includes(query)
        );
      },
      selectResultCity(city) {
        this.search_params.city = city.city;
        this.filters_queries.city = city.city;
        this.filters_results.cities = [];
        this.focusedIndex = -1;
      },

      // to maintain neighborhood search
      filterNeighborhoodResults() {
        const query = this.filters_queries.neighborhood.toLowerCase();
        this.filters_results.neighborhoods = this.filters_options.neighborhoods.filter(neighborhood =>
          neighborhood.toLowerCase().includes(query)
        );
      },
      selectResultNeighborhood(neighborhood) {
        this.search_params.neighborhood = neighborhood;
        this.filters_queries.neighborhood = neighborhood;
        this.filters_results.neighborhoods = [];
        this.focusedIndex = -1;
      },
      
      // centralized search handler
      handleOpenSearch(filterType) {
        this.focusedIndex = -1;

        if (filterType === 'city') {
          this.filterCityResults();
        }
        if (filterType === 'neighborhood') {
          this.filterNeighborhoodResults();
        }
      },
      
      handleSearch() {

        const query = {};
        const params = {};

        if (this.filters_queries.city) {
          query.city = this.slugify(this.filters_queries.city);
          params.city = query.city;
        }

        if (this.filters_queries.neighborhood) {
          query.district = this.slugify(this.filters_queries.neighborhood);
          params.district = query.district; 
        }

        if (this.search_params.propertieType && this.search_params.propertieType.length > 0) {
          query.property_type = this.search_params.propertieType.map((type) => this.slugify(type));
          params.type = query.property_type.length === 1 ? query.property_type[0] : null;
      }


        // const activeTabParam = this.activeTab === 'comprar' ? 'residencial' : 'mensal';
        // query.propertyType = activeTabParam;
        

        // console.log(params);
        // console.log(query);
        
        // redirect with query params
        this.$router.push({
          name: "triplea-property-search",
          query: {
              ...query, 
              //[query.propertyType]: true,
          },
          params: params,
      });
    }

    },
    mounted() {
      document.addEventListener("click", this.handleClickOutside);

      PropertiesService.getFilters().then(response => {

        // save properties types
        this.allPropertyTypes = response.data.types;

        // save cities
        this.filters_options.cities = response.data.cities;

        //get neighborhoods
        const neighborhoods = response.data.enderecos.map(address => address.district);
        // extact and remove duplicated and save neighborhoods
        this.filters_options.neighborhoods = [...new Set(neighborhoods)];


      });
    },
    beforeDestroy() {
      document.removeEventListener("click", this.handleClickOutside);
    },
  };


</script>
